export const routes = {
  ROOT: '/',
  VERIFIER_LOGIN: '/verifier/login',
  VERIFIER_SIGNUP: '/verifier/signup',
  INSTITUTION_LOGIN: '/institution/login',
  INSTITUTION_SIGNUP: '/institution/signup',
  STUDENT_LOGIN: '/student/login',
  STUDENT_SIGNUP: '/student/signup',
  SIGNUP_CONFIRM: '/confirm-signup',
  INTRO: '/intro',
  INSTITUTE: '/institute',
  STUDENT: '/student',
  VERIFIER: '/verifier',
}
